import { render } from "./Step1.vue?vue&type=template&id=2eb7effa"
import script from "./Step1.vue?vue&type=script&lang=js"
export * from "./Step1.vue?vue&type=script&lang=js"
script.render = render

export default script